GloboSwatchConfig.settings = {
            enable_collection_page: true,
            enable_product_page: true,
            out_of_stock: "cross out",
            enable_mandatory: false,
            show_add_to_cart_button: true,
            add_to_cart_ajax: false,
            show_option_name: false,
            add_to_cart_text: "Add to cart",
            added_to_cart_text: "Added to cart",
            sold_out_text: "Sold out",
            text_required: "This field is required",
            sort_option: false        };
        GloboSwatchConfig.options = [{"id":9552,"name":"Size","shop_id":1978,"option_items":[{"id":236444,"value":"S","option_id":9552,"products":[6148350410950,6148350279878,6148037607622],"products_count":3,"select_type":1,"custom":{"color_1":"transparent","color_2":"transparent","upload_file":{"src":null,"server_url":null},"image_url":{"src":null,"server_url":null},"enable_two_color":false,"enable_upload_file":false,"enable_image_url":false}},{"id":236445,"value":"M","option_id":9552,"products":[6148350410950,6148350279878,6148037607622],"products_count":3,"select_type":1,"custom":{"color_1":"transparent","color_2":"transparent","upload_file":{"src":null,"server_url":null},"image_url":{"src":null,"server_url":null},"enable_two_color":false,"enable_upload_file":false,"enable_image_url":false}},{"id":236446,"value":"L","option_id":9552,"products":[6148350410950,6148350279878,6148037607622],"products_count":3,"select_type":1,"custom":{"color_1":"transparent","color_2":"transparent","upload_file":{"src":null,"server_url":null},"image_url":{"src":null,"server_url":null},"enable_two_color":false,"enable_upload_file":false,"enable_image_url":false}},{"id":236447,"value":"XL","option_id":9552,"products":[6148350410950,6148350279878,6148037607622],"products_count":3,"select_type":1,"custom":{"color_1":"transparent","color_2":"transparent","upload_file":{"src":null,"server_url":null},"image_url":{"src":null,"server_url":null},"enable_two_color":false,"enable_upload_file":false,"enable_image_url":false}},{"id":236448,"value":"XXL","option_id":9552,"products":[6148350410950,6148350279878],"products_count":2,"select_type":1,"custom":{"color_1":"transparent","color_2":"transparent","upload_file":{"src":null,"server_url":null},"image_url":{"src":null,"server_url":null},"enable_two_color":false,"enable_upload_file":false,"enable_image_url":false}},{"id":236449,"value":"XXXL","option_id":9552,"products":[6148350410950],"products_count":1,"select_type":1,"custom":{"color_1":"transparent","color_2":"transparent","upload_file":{"src":null,"server_url":null},"image_url":{"src":null,"server_url":null},"enable_two_color":false,"enable_upload_file":false,"enable_image_url":false}},{"id":236450,"value":"Small","option_id":9552,"products":[6148350083270],"products_count":1,"select_type":1,"custom":{"color_1":"transparent","color_2":"transparent","upload_file":{"src":null,"server_url":null},"image_url":{"src":null,"server_url":null},"enable_two_color":false,"enable_upload_file":false,"enable_image_url":false}},{"id":236451,"value":"Medium","option_id":9552,"products":[6148350083270],"products_count":1,"select_type":1,"custom":{"color_1":"transparent","color_2":"transparent","upload_file":{"src":null,"server_url":null},"image_url":{"src":null,"server_url":null},"enable_two_color":false,"enable_upload_file":false,"enable_image_url":false}},{"id":236452,"value":"Large","option_id":9552,"products":[6148350083270],"products_count":1,"select_type":1,"custom":{"color_1":"transparent","color_2":"transparent","upload_file":{"src":null,"server_url":null},"image_url":{"src":null,"server_url":null},"enable_two_color":false,"enable_upload_file":false,"enable_image_url":false}},{"id":236453,"value":"2XL","option_id":9552,"products":[6148037607622],"products_count":1,"select_type":1,"custom":{"color_1":"transparent","color_2":"transparent","upload_file":{"src":null,"server_url":null},"image_url":{"src":null,"server_url":null},"enable_two_color":false,"enable_upload_file":false,"enable_image_url":false}}],"display_style":3,"settings":{"status":true,"enable_collection":true,"type":"swatch"},"products":[6148350410950,6148350083270,6148350279878,6148037607622],"products_count":4,"order":1}];
        GloboSwatchConfig.product_page= {
                customize_swatch: {
                    swatch_shape: 'circle',
                    swatch_size: 'medium',
                    border_style: 'double',
                    border_color: {
                        normal: '#9b9b9b',
                        hover: '#58468c',
                        selected: '#58468c'
                    },
                    hover_effects:{
                        background: 'no effect',
                        zoom_image: 'no zoom',
                        size_change: 'no change'
                    }
                },
                customize_button: {
                    button_corner: 'sharp',
                    button_size: 'medium',
                    border_color: {
                        normal: '#000000',
                        hover: '#000000',
                        selected: '#000000'
                    },
                    text_style: 'default',
                    text_color: {
                        normal: '#000000',
                        hover: '#ffffff',
                        selected: '#ffffff'
                    },
                    background_color: {
                        normal: '#FFFFFF',
                        hover: '#000000',
                        selected: '#000000'
                    },
                    hover_effects:{
                        background: 'no effect',
                    }
                },
                show_number_stock: '',
                float: 'left'
            };
            GloboSwatchConfig.collection_page ={
                customize_swatch: {
                    swatch_shape: 'circle',
                    swatch_size: 'medium',
                    border_style: 'double',
                    border_color: {
                        normal: '#9b9b9b',
                        hover: '#58468c',
                        selected: '#58468c'
                    },
                    hover_effects:{
                        background: 'no effect',
                        zoom_image: 'no zoom',
                        size_change: 'no change'
                    }
                },
                customize_button: {
                    button_corner: 'sharp',
                    button_size: 'medium',
                    border_color: {
                        normal: '#000000',
                        hover: '#000000',
                        selected: '#000000'
                    },
                    text_style: 'default',
                    text_color: {
                        normal: '#0a0a0a',
                        hover: '#ffffff',
                        selected: '#ffffff'
                    },
                    background_color: {
                        normal: '#ffffff',
                        hover: '#000000',
                        selected: '#000000'
                    },
                    hover_effects:{
                        background: 'no effect',
                    }
                },
                float: 'left'
        };